export const AI_ASSISTANT_AVATAR =
  'https://static.mizfa.tools/img/logo/logo-page/mizfa-tools-ai.png';

export const AI_SENDER_NAME = 'دستیار AI میزفا تولز';
